// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   LEAVE ATTENDANCE - RESPONSIVE
   ========================================================= */

/* Main page */
.leave-page {
    width: 100%;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 20px;
    background: #f6f9fc;
    overflow-x: hidden;
}


/* =========================================================
   HEADER
   ========================================================= */

.leave-header {
    width: 100%;
    box-sizing: border-box;

    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 15px;

    background: #fff;
    padding: 15px 20px;
    border-radius: 12px;
    margin-bottom: 20px;
}

.leave-header h2 {
    margin: 0;
    white-space: nowrap;
}

.leave-header .search-input {
    width: 280px;
    max-width: 100%;
    box-sizing: border-box;
}


/* =========================================================
   FILTER ROW
   ========================================================= */

.filter-row {
    width: 100%;
    box-sizing: border-box;

    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;

    gap: 12px;

    margin-bottom: 20px;
}

.filter-group {
    display: flex;
    flex-direction: column;
}

.filter-group label {
    margin-bottom: 5px;
    font-size: 13px;
    font-weight: 600;
}

.filter-row input,
.filter-row select {
    box-sizing: border-box;

    padding: 8px 10px;
    border-radius: 10px;
    border: 1px solid #ddd;

    min-width: 140px;
}


/* DOWNLOAD BUTTON */

.download-btn {
    background: #2563eb;
    color: white;

    border: none;
    border-radius: 20px;

    padding: 8px 16px;

    margin-top: 0;
    margin-left: 10px;

    width: 180px;
    min-height: 38px;

    cursor: pointer;
    white-space: nowrap;
}


/* =========================================================
   TABLE CARD
   ========================================================= */

.table-card {
    width: 100%;
    box-sizing: border-box;

    background: white;
    border-radius: 14px;
    padding: 15px;

    overflow: hidden;
}


/*
   IMPORTANT:
   Table scrolls horizontally on mobile.
*/
.table-card {
    overflow-x: auto;
    overflow-y: hidden;

    -webkit-overflow-scrolling: touch;
}


/* TABLE */

.table-card table {
    width: 100%;
    min-width: 1100px;

    border-collapse: collapse;
}

.table-card th {
    background: #f1f5f9;
    padding: 10px;
    text-align: left;

    white-space: nowrap;
}

.table-card td {
    padding: 10px;
    border-bottom: 1px solid #eee;

    vertical-align: middle;
}


/* =========================================================
   REASON COLUMN
   ========================================================= */

.reason-column {
    width: 280px !important;
    min-width: 280px !important;
    max-width: 280px !important;
}

.reason-cell {
    width: 280px !important;
    min-width: 280px !important;
    max-width: 280px !important;

    padding: 8px !important;
}

/*
   Only the reason text scrolls.
*/
.reason-scroll {
    width: 100%;
    max-width: 100%;

    height: 80px;
    max-height: 80px;

    overflow-y: auto;
    overflow-x: hidden;

    box-sizing: border-box;

    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;

    line-height: 1.4;

    padding: 4px 6px 4px 2px;
}


/* Reason scrollbar */

.reason-scroll::-webkit-scrollbar {
    width: 5px;
}

.reason-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.reason-scroll::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.reason-scroll::-webkit-scrollbar-thumb:hover {
    background: #999;
}


/* =========================================================
   BUTTONS
   ========================================================= */

.approve-btn,
.reject-btn,
.view-btn {
    white-space: nowrap;
    cursor: pointer;
}

.approve-btn {
    background: #22c55e;
    color: white;
    border: none;

    padding: 6px 12px;
    border-radius: 20px;

    margin-right: 6px;
}

.reject-btn {
    background: #ef4444;
    color: white;
    border: none;

    padding: 6px 12px;
    border-radius: 20px;
}

.view-btn {
    background: #2563eb;
    color: white;
    border: none;

    padding: 6px 12px;
    border-radius: 20px;

    width: 90px;
    margin-left: 20px;
}


/* =========================================================
   PAGINATION
   ========================================================= */

.pagination-section {
    width: 100%;
    box-sizing: border-box;

    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 15px;

    padding: 15px 20px;
    background: #fff;
}

.pagination-section > span,
.pagination-section > p {
    margin: 0;
    font-size: 14px;
}

.pagination {
    display: flex;
    align-items: center;

    gap: 0;

    list-style: none;
    padding: 0;
    margin: 0;
}

.pagination li {
    list-style: none;
    margin: 0;
    padding: 0;
}

.pagination li button {
    width: 35px;
    height: 35px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #fff;
    color: #d71920;

    border: 1px solid #d5d5d5;

    border-radius: 8px;

    font-size: 20px;
    font-weight: 600;

    cursor: pointer;
    margin-left: 0;
}

.pagination li + li button {
    border-left: 0;
    border-radius: 0;
}

.pagination li:first-child button {
    border-radius: 8px 0 0 8px;
}

.pagination li:last-child button {
    border-radius: 0 8px 8px 0;
}

.pagination li.active button {
    background: #d71920;
    color: #fff;
    border-color: #d71920;
}

.pagination li:not(.active):not(.disabled) button:hover {
    background: #fff5f5;
    color: #b51218;
}

.pagination li.disabled button {
    color: #aaa;
    background: #fff;
    cursor: not-allowed;
    opacity: 0.6;
}


/* =========================================================
   MODAL
   ========================================================= */

.modal-overlay {
    position: fixed;
    inset: 0;

    width: 100%;
    height: 100%;

    background: rgba(0, 0, 0, 0.4);

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 15px;
    box-sizing: border-box;

    z-index: 9999;
}

.modal-box {
    background: white;

    padding: 20px;

    width: 400px;
    max-width: 100%;

    max-height: 90vh;

    border-radius: 16px;

    box-sizing: border-box;

    overflow-y: auto;
}

.modal-box textarea {
    width: 100%;
    max-width: 100%;

    height: 80px;

    margin-top: 10px;

    border-radius: 10px;
    padding: 10px;

    box-sizing: border-box;
    resize: vertical;
}

.modal-actions {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 15px;
}


/* =========================================================
   STATUS
   ========================================================= */

.approved {
    color: green;
    font-weight: bold;
}

.rejected {
    color: red;
    font-weight: bold;
}

.pending {
    color: orange;
    font-weight: bold;
}


/* =========================================================
   TABLET
   ========================================================= */

@media (max-width: 992px) {

    .leave-page {
        padding: 15px;
    }

    .leave-header {
        flex-wrap: wrap;
    }

    .leave-header .search-input {
        width: 100%;
        max-width: 350px;
    }

    .filter-row {
        align-items: stretch;
    }

    .filter-group {
        flex: 1 1 180px;
    }

    .filter-row input,
    .filter-row select {
        width: 100%;
    }

    .download-btn {
        margin-left: 0;
    }
}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 768px) {

    .leave-page {
        width: 100%;
        min-height: 100vh;

        padding: 12px;

        box-sizing: border-box;

        overflow-x: hidden;
    }


    /* HEADER */

    .leave-header {
        width: 100%;

        display: flex;
        flex-direction: column;

        align-items: stretch;
        justify-content: flex-start;

        padding: 15px;

        border-radius: 15px;

        gap: 12px;
    }

    .leave-header h2 {
        font-size: 20px;
        text-align: left;
    }

    .leave-header .search-input {
        width: 100%;
        max-width: 100%;

        height: 42px;
        box-sizing: border-box;
    }


    /* FILTERS */

    .filter-row {
        width: 100%;

        display: flex;
        flex-direction: column;

        align-items: stretch;

        gap: 12px;
    }

    .filter-group {
        width: 100%;
    }

    .filter-group label {
        font-size: 13px;
    }

    .filter-row input,
    .filter-row select {
        width: 100%;

        min-width: 0;

        height: 42px;
        box-sizing: border-box;
    }


    /* DOWNLOAD */

    .download-btn {
        width: 100%;

        margin: 5px 0 0 0;

        height: 42px;
    }


    /* TABLE */

    .table-card {
        width: 100%;

        padding: 10px;

        border-radius: 12px;

        overflow-x: auto;
        overflow-y: hidden;

        -webkit-overflow-scrolling: touch;
    }

    /*
       Keep table wide enough to read.
       User can swipe horizontally.
    */
    .table-card table {
        width: 1100px;
        min-width: 1100px;
    }

    .table-card th {
        padding: 9px;
        font-size: 12px;
    }

    .table-card td {
        padding: 9px;
        font-size: 12px;
    }


    /* REASON */

    .reason-column {
        width: 280px !important;
        min-width: 280px !important;
        max-width: 280px !important;
    }

    .reason-cell {
        width: 280px !important;
        min-width: 280px !important;
        max-width: 280px !important;
    }

    .reason-scroll {
        height: 75px;
        max-height: 75px;

        overflow-y: auto;
        overflow-x: hidden;
    }


    /* BUTTONS */

    .approve-btn,
    .reject-btn {
        padding: 6px 10px;
        font-size: 12px;
    }

    .view-btn {
        width: 75px;

        padding: 6px 10px;

        font-size: 12px;

        margin-left: 10px;
    }


    /* PAGINATION */

    .pagination-section {
        width: 100%;

        display: flex;
        flex-direction: column;

        justify-content: center;
        align-items: center;

        gap: 12px;

        padding: 15px 10px;

        box-sizing: border-box;
    }

    .pagination-section > span,
    .pagination-section > p {
        width: 100%;

        text-align: center;

        font-size: 13px;
    }

    .pagination {
        justify-content: center;
    }

    .pagination li button {
        width: 38px;
        height: 38px;

        font-size: 18px;
    }


    /* MODAL */

    .modal-overlay {
        padding: 12px;
    }

    .modal-box {
        width: 100%;
        max-width: 400px;

        padding: 18px;

        border-radius: 14px;
    }

    .modal-box textarea {
        width: 100%;
        height: 100px;
    }
}


/* =========================================================
   SMALL MOBILE
   ========================================================= */

@media (max-width: 480px) {

    .leave-page {
        padding: 8px;
    }

    .leave-header {
        padding: 12px;
    }

    .leave-header h2 {
        font-size: 18px;
    }

    .filter-row {
        gap: 10px;
    }

    .table-card {
        padding: 8px;
    }

    .table-card table {
        min-width: 1050px;
    }

    .reason-scroll {
        height: 70px;
        max-height: 70px;
    }

    .pagination li button {
        width: 34px;
        height: 34px;

        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/LeaveAttendance.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D,cAAc;AACd;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;;IAEtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB,SAAS;;IAET,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;;IAEtB,aAAa;IACb,qBAAqB;IACrB,eAAe;;IAEf,SAAS;;IAET,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;;IAEtB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;;IAEtB,gBAAgB;AACpB;;;AAGA,oBAAoB;;AAEpB;IACI,mBAAmB;IACnB,YAAY;;IAEZ,YAAY;IACZ,mBAAmB;;IAEnB,iBAAiB;;IAEjB,aAAa;IACb,iBAAiB;;IAEjB,YAAY;IACZ,gBAAgB;;IAEhB,eAAe;IACf,mBAAmB;AACvB;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;;IAEtB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;;IAEb,gBAAgB;AACpB;;;AAGA;;;CAGC;AACD;IACI,gBAAgB;IAChB,kBAAkB;;IAElB,iCAAiC;AACrC;;;AAGA,UAAU;;AAEV;IACI,WAAW;IACX,iBAAiB;;IAEjB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;;IAEhB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;;IAE7B,sBAAsB;AAC1B;;;AAGA;;8DAE8D;;AAE9D;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;;IAE3B,uBAAuB;AAC3B;;AAEA;;CAEC;AACD;IACI,WAAW;IACX,eAAe;;IAEf,YAAY;IACZ,gBAAgB;;IAEhB,gBAAgB;IAChB,kBAAkB;;IAElB,sBAAsB;;IAEtB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;;IAEvB,gBAAgB;;IAEhB,wBAAwB;AAC5B;;;AAGA,qBAAqB;;AAErB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;;8DAE8D;;AAE9D;;;IAGI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;;IAEZ,iBAAiB;IACjB,mBAAmB;;IAEnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;;IAEZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;;IAEZ,iBAAiB;IACjB,mBAAmB;;IAEnB,WAAW;IACX,iBAAiB;AACrB;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;;IAEtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB,SAAS;;IAET,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,MAAM;;IAEN,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,gBAAgB;IAChB,cAAc;;IAEd,yBAAyB;;IAEzB,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;;IAEhB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;;8DAE8D;;AAE9D;IACI,eAAe;IACf,QAAQ;;IAER,WAAW;IACX,YAAY;;IAEZ,8BAA8B;;IAE9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;;IAEtB,aAAa;AACjB;;AAEA;IACI,iBAAiB;;IAEjB,aAAa;;IAEb,YAAY;IACZ,eAAe;;IAEf,gBAAgB;;IAEhB,mBAAmB;;IAEnB,sBAAsB;;IAEtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;;IAEf,YAAY;;IAEZ,gBAAgB;;IAEhB,mBAAmB;IACnB,aAAa;;IAEb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;;AAGA;;8DAE8D;;AAE9D;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;;AAGA;;8DAE8D;;AAE9D;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;AACJ;;;AAGA;;8DAE8D;;AAE9D;;IAEI;QACI,WAAW;QACX,iBAAiB;;QAEjB,aAAa;;QAEb,sBAAsB;;QAEtB,kBAAkB;IACtB;;;IAGA,WAAW;;IAEX;QACI,WAAW;;QAEX,aAAa;QACb,sBAAsB;;QAEtB,oBAAoB;QACpB,2BAA2B;;QAE3B,aAAa;;QAEb,mBAAmB;;QAEnB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;;QAEf,YAAY;QACZ,sBAAsB;IAC1B;;;IAGA,YAAY;;IAEZ;QACI,WAAW;;QAEX,aAAa;QACb,sBAAsB;;QAEtB,oBAAoB;;QAEpB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,WAAW;;QAEX,YAAY;;QAEZ,YAAY;QACZ,sBAAsB;IAC1B;;;IAGA,aAAa;;IAEb;QACI,WAAW;;QAEX,iBAAiB;;QAEjB,YAAY;IAChB;;;IAGA,UAAU;;IAEV;QACI,WAAW;;QAEX,aAAa;;QAEb,mBAAmB;;QAEnB,gBAAgB;QAChB,kBAAkB;;QAElB,iCAAiC;IACrC;;IAEA;;;KAGC;IACD;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;;IAGA,WAAW;;IAEX;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,2BAA2B;IAC/B;;IAEA;QACI,YAAY;QACZ,gBAAgB;;QAEhB,gBAAgB;QAChB,kBAAkB;IACtB;;;IAGA,YAAY;;IAEZ;;QAEI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;;QAEX,iBAAiB;;QAEjB,eAAe;;QAEf,iBAAiB;IACrB;;;IAGA,eAAe;;IAEf;QACI,WAAW;;QAEX,aAAa;QACb,sBAAsB;;QAEtB,uBAAuB;QACvB,mBAAmB;;QAEnB,SAAS;;QAET,kBAAkB;;QAElB,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;;QAEX,kBAAkB;;QAElB,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;;QAEZ,eAAe;IACnB;;;IAGA,UAAU;;IAEV;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;;QAEhB,aAAa;;QAEb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;;AAGA;;8DAE8D;;AAE9D;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;;QAEZ,eAAe;IACnB;AACJ","sourcesContent":["/* =========================================================\r\n   LEAVE ATTENDANCE - RESPONSIVE\r\n   ========================================================= */\r\n\r\n/* Main page */\r\n.leave-page {\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    box-sizing: border-box;\r\n    padding: 20px;\r\n    background: #f6f9fc;\r\n    overflow-x: hidden;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   HEADER\r\n   ========================================================= */\r\n\r\n.leave-header {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    gap: 15px;\r\n\r\n    background: #fff;\r\n    padding: 15px 20px;\r\n    border-radius: 12px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.leave-header h2 {\r\n    margin: 0;\r\n    white-space: nowrap;\r\n}\r\n\r\n.leave-header .search-input {\r\n    width: 280px;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   FILTER ROW\r\n   ========================================================= */\r\n\r\n.filter-row {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    display: flex;\r\n    align-items: flex-end;\r\n    flex-wrap: wrap;\r\n\r\n    gap: 12px;\r\n\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.filter-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.filter-group label {\r\n    margin-bottom: 5px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n}\r\n\r\n.filter-row input,\r\n.filter-row select {\r\n    box-sizing: border-box;\r\n\r\n    padding: 8px 10px;\r\n    border-radius: 10px;\r\n    border: 1px solid #ddd;\r\n\r\n    min-width: 140px;\r\n}\r\n\r\n\r\n/* DOWNLOAD BUTTON */\r\n\r\n.download-btn {\r\n    background: #2563eb;\r\n    color: white;\r\n\r\n    border: none;\r\n    border-radius: 20px;\r\n\r\n    padding: 8px 16px;\r\n\r\n    margin-top: 0;\r\n    margin-left: 10px;\r\n\r\n    width: 180px;\r\n    min-height: 38px;\r\n\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   TABLE CARD\r\n   ========================================================= */\r\n\r\n.table-card {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    background: white;\r\n    border-radius: 14px;\r\n    padding: 15px;\r\n\r\n    overflow: hidden;\r\n}\r\n\r\n\r\n/*\r\n   IMPORTANT:\r\n   Table scrolls horizontally on mobile.\r\n*/\r\n.table-card {\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n\r\n/* TABLE */\r\n\r\n.table-card table {\r\n    width: 100%;\r\n    min-width: 1100px;\r\n\r\n    border-collapse: collapse;\r\n}\r\n\r\n.table-card th {\r\n    background: #f1f5f9;\r\n    padding: 10px;\r\n    text-align: left;\r\n\r\n    white-space: nowrap;\r\n}\r\n\r\n.table-card td {\r\n    padding: 10px;\r\n    border-bottom: 1px solid #eee;\r\n\r\n    vertical-align: middle;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   REASON COLUMN\r\n   ========================================================= */\r\n\r\n.reason-column {\r\n    width: 280px !important;\r\n    min-width: 280px !important;\r\n    max-width: 280px !important;\r\n}\r\n\r\n.reason-cell {\r\n    width: 280px !important;\r\n    min-width: 280px !important;\r\n    max-width: 280px !important;\r\n\r\n    padding: 8px !important;\r\n}\r\n\r\n/*\r\n   Only the reason text scrolls.\r\n*/\r\n.reason-scroll {\r\n    width: 100%;\r\n    max-width: 100%;\r\n\r\n    height: 80px;\r\n    max-height: 80px;\r\n\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n\r\n    box-sizing: border-box;\r\n\r\n    white-space: normal;\r\n    word-break: break-word;\r\n    overflow-wrap: anywhere;\r\n\r\n    line-height: 1.4;\r\n\r\n    padding: 4px 6px 4px 2px;\r\n}\r\n\r\n\r\n/* Reason scrollbar */\r\n\r\n.reason-scroll::-webkit-scrollbar {\r\n    width: 5px;\r\n}\r\n\r\n.reason-scroll::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 5px;\r\n}\r\n\r\n.reason-scroll::-webkit-scrollbar-thumb {\r\n    background: #c1c1c1;\r\n    border-radius: 5px;\r\n}\r\n\r\n.reason-scroll::-webkit-scrollbar-thumb:hover {\r\n    background: #999;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   BUTTONS\r\n   ========================================================= */\r\n\r\n.approve-btn,\r\n.reject-btn,\r\n.view-btn {\r\n    white-space: nowrap;\r\n    cursor: pointer;\r\n}\r\n\r\n.approve-btn {\r\n    background: #22c55e;\r\n    color: white;\r\n    border: none;\r\n\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n\r\n    margin-right: 6px;\r\n}\r\n\r\n.reject-btn {\r\n    background: #ef4444;\r\n    color: white;\r\n    border: none;\r\n\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n}\r\n\r\n.view-btn {\r\n    background: #2563eb;\r\n    color: white;\r\n    border: none;\r\n\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n\r\n    width: 90px;\r\n    margin-left: 20px;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   PAGINATION\r\n   ========================================================= */\r\n\r\n.pagination-section {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    gap: 15px;\r\n\r\n    padding: 15px 20px;\r\n    background: #fff;\r\n}\r\n\r\n.pagination-section > span,\r\n.pagination-section > p {\r\n    margin: 0;\r\n    font-size: 14px;\r\n}\r\n\r\n.pagination {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    gap: 0;\r\n\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.pagination li {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.pagination li button {\r\n    width: 35px;\r\n    height: 35px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    background: #fff;\r\n    color: #d71920;\r\n\r\n    border: 1px solid #d5d5d5;\r\n\r\n    border-radius: 8px;\r\n\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n\r\n    cursor: pointer;\r\n    margin-left: 0;\r\n}\r\n\r\n.pagination li + li button {\r\n    border-left: 0;\r\n    border-radius: 0;\r\n}\r\n\r\n.pagination li:first-child button {\r\n    border-radius: 8px 0 0 8px;\r\n}\r\n\r\n.pagination li:last-child button {\r\n    border-radius: 0 8px 8px 0;\r\n}\r\n\r\n.pagination li.active button {\r\n    background: #d71920;\r\n    color: #fff;\r\n    border-color: #d71920;\r\n}\r\n\r\n.pagination li:not(.active):not(.disabled) button:hover {\r\n    background: #fff5f5;\r\n    color: #b51218;\r\n}\r\n\r\n.pagination li.disabled button {\r\n    color: #aaa;\r\n    background: #fff;\r\n    cursor: not-allowed;\r\n    opacity: 0.6;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   MODAL\r\n   ========================================================= */\r\n\r\n.modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    background: rgba(0, 0, 0, 0.4);\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    padding: 15px;\r\n    box-sizing: border-box;\r\n\r\n    z-index: 9999;\r\n}\r\n\r\n.modal-box {\r\n    background: white;\r\n\r\n    padding: 20px;\r\n\r\n    width: 400px;\r\n    max-width: 100%;\r\n\r\n    max-height: 90vh;\r\n\r\n    border-radius: 16px;\r\n\r\n    box-sizing: border-box;\r\n\r\n    overflow-y: auto;\r\n}\r\n\r\n.modal-box textarea {\r\n    width: 100%;\r\n    max-width: 100%;\r\n\r\n    height: 80px;\r\n\r\n    margin-top: 10px;\r\n\r\n    border-radius: 10px;\r\n    padding: 10px;\r\n\r\n    box-sizing: border-box;\r\n    resize: vertical;\r\n}\r\n\r\n.modal-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 12px;\r\n    margin-top: 15px;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   STATUS\r\n   ========================================================= */\r\n\r\n.approved {\r\n    color: green;\r\n    font-weight: bold;\r\n}\r\n\r\n.rejected {\r\n    color: red;\r\n    font-weight: bold;\r\n}\r\n\r\n.pending {\r\n    color: orange;\r\n    font-weight: bold;\r\n}\r\n\r\n\r\n/* =========================================================\r\n   TABLET\r\n   ========================================================= */\r\n\r\n@media (max-width: 992px) {\r\n\r\n    .leave-page {\r\n        padding: 15px;\r\n    }\r\n\r\n    .leave-header {\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .leave-header .search-input {\r\n        width: 100%;\r\n        max-width: 350px;\r\n    }\r\n\r\n    .filter-row {\r\n        align-items: stretch;\r\n    }\r\n\r\n    .filter-group {\r\n        flex: 1 1 180px;\r\n    }\r\n\r\n    .filter-row input,\r\n    .filter-row select {\r\n        width: 100%;\r\n    }\r\n\r\n    .download-btn {\r\n        margin-left: 0;\r\n    }\r\n}\r\n\r\n\r\n/* =========================================================\r\n   MOBILE\r\n   ========================================================= */\r\n\r\n@media (max-width: 768px) {\r\n\r\n    .leave-page {\r\n        width: 100%;\r\n        min-height: 100vh;\r\n\r\n        padding: 12px;\r\n\r\n        box-sizing: border-box;\r\n\r\n        overflow-x: hidden;\r\n    }\r\n\r\n\r\n    /* HEADER */\r\n\r\n    .leave-header {\r\n        width: 100%;\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        align-items: stretch;\r\n        justify-content: flex-start;\r\n\r\n        padding: 15px;\r\n\r\n        border-radius: 15px;\r\n\r\n        gap: 12px;\r\n    }\r\n\r\n    .leave-header h2 {\r\n        font-size: 20px;\r\n        text-align: left;\r\n    }\r\n\r\n    .leave-header .search-input {\r\n        width: 100%;\r\n        max-width: 100%;\r\n\r\n        height: 42px;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n\r\n    /* FILTERS */\r\n\r\n    .filter-row {\r\n        width: 100%;\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        align-items: stretch;\r\n\r\n        gap: 12px;\r\n    }\r\n\r\n    .filter-group {\r\n        width: 100%;\r\n    }\r\n\r\n    .filter-group label {\r\n        font-size: 13px;\r\n    }\r\n\r\n    .filter-row input,\r\n    .filter-row select {\r\n        width: 100%;\r\n\r\n        min-width: 0;\r\n\r\n        height: 42px;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n\r\n    /* DOWNLOAD */\r\n\r\n    .download-btn {\r\n        width: 100%;\r\n\r\n        margin: 5px 0 0 0;\r\n\r\n        height: 42px;\r\n    }\r\n\r\n\r\n    /* TABLE */\r\n\r\n    .table-card {\r\n        width: 100%;\r\n\r\n        padding: 10px;\r\n\r\n        border-radius: 12px;\r\n\r\n        overflow-x: auto;\r\n        overflow-y: hidden;\r\n\r\n        -webkit-overflow-scrolling: touch;\r\n    }\r\n\r\n    /*\r\n       Keep table wide enough to read.\r\n       User can swipe horizontally.\r\n    */\r\n    .table-card table {\r\n        width: 1100px;\r\n        min-width: 1100px;\r\n    }\r\n\r\n    .table-card th {\r\n        padding: 9px;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .table-card td {\r\n        padding: 9px;\r\n        font-size: 12px;\r\n    }\r\n\r\n\r\n    /* REASON */\r\n\r\n    .reason-column {\r\n        width: 280px !important;\r\n        min-width: 280px !important;\r\n        max-width: 280px !important;\r\n    }\r\n\r\n    .reason-cell {\r\n        width: 280px !important;\r\n        min-width: 280px !important;\r\n        max-width: 280px !important;\r\n    }\r\n\r\n    .reason-scroll {\r\n        height: 75px;\r\n        max-height: 75px;\r\n\r\n        overflow-y: auto;\r\n        overflow-x: hidden;\r\n    }\r\n\r\n\r\n    /* BUTTONS */\r\n\r\n    .approve-btn,\r\n    .reject-btn {\r\n        padding: 6px 10px;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .view-btn {\r\n        width: 75px;\r\n\r\n        padding: 6px 10px;\r\n\r\n        font-size: 12px;\r\n\r\n        margin-left: 10px;\r\n    }\r\n\r\n\r\n    /* PAGINATION */\r\n\r\n    .pagination-section {\r\n        width: 100%;\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        gap: 12px;\r\n\r\n        padding: 15px 10px;\r\n\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .pagination-section > span,\r\n    .pagination-section > p {\r\n        width: 100%;\r\n\r\n        text-align: center;\r\n\r\n        font-size: 13px;\r\n    }\r\n\r\n    .pagination {\r\n        justify-content: center;\r\n    }\r\n\r\n    .pagination li button {\r\n        width: 38px;\r\n        height: 38px;\r\n\r\n        font-size: 18px;\r\n    }\r\n\r\n\r\n    /* MODAL */\r\n\r\n    .modal-overlay {\r\n        padding: 12px;\r\n    }\r\n\r\n    .modal-box {\r\n        width: 100%;\r\n        max-width: 400px;\r\n\r\n        padding: 18px;\r\n\r\n        border-radius: 14px;\r\n    }\r\n\r\n    .modal-box textarea {\r\n        width: 100%;\r\n        height: 100px;\r\n    }\r\n}\r\n\r\n\r\n/* =========================================================\r\n   SMALL MOBILE\r\n   ========================================================= */\r\n\r\n@media (max-width: 480px) {\r\n\r\n    .leave-page {\r\n        padding: 8px;\r\n    }\r\n\r\n    .leave-header {\r\n        padding: 12px;\r\n    }\r\n\r\n    .leave-header h2 {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .filter-row {\r\n        gap: 10px;\r\n    }\r\n\r\n    .table-card {\r\n        padding: 8px;\r\n    }\r\n\r\n    .table-card table {\r\n        min-width: 1050px;\r\n    }\r\n\r\n    .reason-scroll {\r\n        height: 70px;\r\n        max-height: 70px;\r\n    }\r\n\r\n    .pagination li button {\r\n        width: 34px;\r\n        height: 34px;\r\n\r\n        font-size: 16px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
